import { t } from 'i18next';

export class HttpError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'HttpError';
  }
}

export class HttpResponseParsingError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'HttpResponseParsingError';
  }
}

export class InvalidUrlError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'InvalidUrlError';
  }
}

export class AuthenticationError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'AuthenticationError';
  }
}

/**
 * Error for when a user doesn't have permissions to access a specific element.
 */
export class AuthorizationError extends Error {
  constructor(readonly redirectTo: string) {
    super();
    this.name = 'AuthorizationError';
  }
}

export type ErrorMessages = {
  fallback?: string;
  authError?: string;
  responseError?: string;
  httpError?: string;
  invalidUrl?: string;
};

export const getErrorMessage = (e: unknown, messages?: ErrorMessages): string => {
  const { fallback, authError, responseError, httpError, invalidUrl } = messages || {};
  if (e instanceof InvalidUrlError) {
    return invalidUrl || fallback || t('notFound');
  }
  if (e instanceof HttpResponseParsingError) {
    return responseError || fallback || t('somethingWentWrong');
  }
  if (e instanceof AuthenticationError) {
    return e.message || authError || fallback || t('authenticationErrorMessage');
  }
  if (e instanceof AuthorizationError) {
    return t('authorizationErrorMessage');
  }
  if (e instanceof HttpError) {
    return e.message || httpError || fallback || t('somethingWentWrong');
  }
  return fallback || t('somethingWentWrong');
};
